import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { SurveyService } from '../service/survey.service';
import { UtilityService } from 'src/app/service/utility.service';

@Component({
  selector: 'app-quota',
  templateUrl: './quota.component.html',
  styleUrls: ['./quota.component.scss']
})
export class QuotaComponent implements OnInit {
  public quotas: any = [];
  public quotaDetails:any = [];
  public suvDetails: any = {};
  public subQuotaTableContainer:any = [];
  public showAllContainers: any = ['All','Container-1 (Active)','Container-2 (Inactive)','Container-3 (Expired)','Container-4 (Active)'];
  public containerHoverIndex = -1;

  constructor(
    public surveyService:SurveyService,
    public route:Router,
    public activeRoute:ActivatedRoute,
    private cd: ChangeDetectorRef,
    public utility:UtilityService,

  ) { }

  ngOnInit(): void {
    this.checkRedirectFrom();
    this.setFormFields();
    this.getSurvayDetails();
    this.getQuotaDetails();
    // this.selectedContainer();

    // console.log(this.surveyService.surveyReport,'Hiiiiiiii');
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // this.surveyService.getquotaDetail(survey_id);
  }
  ngOnDestroy(): void{
    this.surveyService.defaultSurveyGetLink = 1;
    this.surveyService.quotaType = 'shared';
  }


  checkRedirectFrom(){
    if(localStorage.getItem('redirectFromCompletionSurveyDetails')){
      this.surveyService.redirectFromCompletion = true;
      this.surveyService.redirectFromInventory = false;
      let surveyDeatils:any = localStorage.getItem('redirectFromCompletionSurveyDetails');
      surveyDeatils = JSON.parse(surveyDeatils);
      this.surveyService.redirectFromCompletionSurveyDetails = surveyDeatils;
      
      // this.surveyService.selected_container = surveyDeatils.selected_container;

    }
    else
    {
      this.surveyService.redirectFromCompletion = false;
      this.surveyService.redirectFromInventory = true;
      this.surveyService.selected_container = {'container_name':'Container All','status':'Active','container_id':''};
    }
  }
  
  getQuotaDetails(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
    let container_id = "";
    if(localStorage.getItem('selected_container')){
      let selected_container:any = localStorage.getItem('selected_container');
      selected_container = JSON.parse(selected_container);
      this.surveyService.selected_container =selected_container;
      container_id = selected_container.container_id;
    }
    this.surveyService.getQuotaDetails(survey_id,container_id)
    .subscribe({
      next: (res: any) =>{
        if (res['status'] == 1) {
          this.quotaDetails = res.result;
          this.cd.detectChanges();
          // console.log("details is ====>",this.suvDetails);
        }
      },error :(e) =>{
        console.log(e)
      }
    })
  }

  // getQuotaDetail(sId:any){
  //   this.surveyService.getQuotaDetails(sId).subscribe((result) =>
  //   {
  //     if(result['status'] === 1)
  //     {
  //       this.quotaDetails = result['result'];
  //       console.log(this.quotaDetails,'How are You');
  //     }
  //     else
  //     {

  //     }
  //   })

  // }


  setFormFields() {
    this.quotas = [
      {name:'Delhi NCR',required:'250',completed:"150"},
      {name:'Male',required:'128',completed:"99"},
      {name:'Female',required:'140',completed:"112"},
      {name:'25 - 35',required:'70',completed:"43"}
    ];
  }
  detailsRouterChange(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // console.log(survey_id,'sURVEYiD');
    this.route.navigate([`/survey/details/${survey_id}`]);
  }
  quotaRouterChange(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // console.log(survey_id);
    this.route.navigate([`/survey/quota/${survey_id}`]);
  }

  tgQuotaRouterChange(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // console.log(survey_id);
    this.route.navigate([`/survey/target-group/${survey_id}`]);
  }
  // uploadRejectionRouterChange(){
  //   let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
  //   this.route.navigate([`/survey/operations/${survey_id}`]);
  // }
  
  getSurvayDetails(){
    if(!Object.keys(this.surveyService.surveyDetails).length)
    {
      let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
      let container_id = "";
      if(localStorage.getItem('selected_container')){
        let selected_container:any = localStorage.getItem('selected_container');
        selected_container = JSON.parse(selected_container);
        this.surveyService.selected_container =selected_container;
        container_id = selected_container.container_id;
      }
      this.surveyService.getSurvayDetails(survey_id,container_id)
      .subscribe({
        next: (res: any) =>{
          if (res['status'] == 1) {
            this.suvDetails = res.result;
            this.suvDetails['total_sample_size'] =( res.result.achieved_sample || '-') + "/" + (res.result.sample_size || '-');
            this.suvDetails['crownit_sample_size'] = ( res.result.crownit_achieved_sample || '0') + "/" + (res.result.crownit_sample_size	 || '0');
            // this.surveyService.surveyDetails = res['result'];
            this.surveyService.surveyDetails = this.suvDetails;
            this.surveyService.setContainers(this.suvDetails);
            this.surveyService.selectedContainer();
            this.cd.detectChanges();
          }
        },error :(e) =>{
          console.log(e)
        }
      })
    }
    else
    {
      this.suvDetails = this.surveyService.surveyDetails;
    }
    
  }
  InnerSubTableOpen(ind:any){
    let findex = this.subQuotaTableContainer.findIndex((va:any) => va === ind);
    if(findex === -1)
    {
      this.subQuotaTableContainer.push(ind);
    }
    else
    {
      this.subQuotaTableContainer.splice(findex,1);
    }
  }
  CheckSubQuotaOpen(ind:any){
    let findex = this.subQuotaTableContainer.findIndex((va:any) => va === ind);
    if(findex != -1){
      return 1;
    }
    return 0;
  }
  CheckArrowDirection(ind:number){
    let findex = this.subQuotaTableContainer.findIndex((va:any) => va === ind);
    if(findex != -1){
      return 1;
    }
    return 0;
  }
 
  getLinkDetails(flag:number){
    if(flag === 0)
    {
      let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
      this.surveyService.getDownloadLinkDetails(survey_id,1)
      .subscribe({
        next: (res: any) =>{
          if (res['status'] == 1) {
            this.surveyService.SurveyGetLink = res['links'];
            this.cd.detectChanges();
            this.utility.copyOnClick(res['links'][0]);
  
          }
        },error :(e) =>{
          console.log(e)
        }
      })
    }
    else
    {
      let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
      this.surveyService.getDownloadLinkDetails(survey_id,this.surveyService.defaultSurveyGetLink)
      .subscribe({
        next: (res: any) =>{
          if (res['status'] == 1) {
            this.surveyService.SurveyGetLink = res['links'];
            this.cd.detectChanges();
            // this.utility.copyOnClick(res['links'][0]);
            this.surveyService.downloadLink(res['links']);
          }
        },error :(e) =>{
          console.log(e)
        }
      })

    }
   
  }

  getTestLinkDetails(link:any){
    this.utility.copyOnClick(link)
  }


  changeContainerBgColor(index:any){
    this.containerHoverIndex = index;
   
  }


 


  switchContainerCall(item:any){
    this.surveyService.selected_container = item;
    localStorage.setItem('selected_container',JSON.stringify(item));
    this.surveyService.surveyDetails = {};
    this.getSurvayDetails();
    this.getQuotaDetails();
  }

  onQuoteTypeChange(){
    this.quotaDetails = [];
    this.getQuotaDetails();
  }





 
}
